import { Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { tap } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class SeoMetaTagService {
    constructor(
        private _translocoService: TranslocoService
    ) {
    }
    public SetMetaTitleByUrl(url: string) {
        let title = this.resolveMetaTitleByUrl(url);
        this.SetMetaTitle(title);
    }

    public SetMetaTitle(title: string) {
        this._translocoService.selectTranslate(title).pipe(
            tap(t => {
                if (!t) {
                    t = 'Uniko';
                }
                const metaTitle = document.querySelector('meta[name="title"]');
                if (metaTitle) {
                    metaTitle.setAttribute('content', t);
                } else {
                    const newMetaTitle = document.createElement('meta');
                    newMetaTitle.setAttribute('name', 'title');
                    newMetaTitle.setAttribute('content', t);
                    document.head.appendChild(newMetaTitle);
                }
                document.title = t;
            }),
        ).subscribe();
    }

    public SetMetaDescriptionByUrl(url: string) {
        let description = this.resolveMetaDesciptionByUrl(url);
        this.SetMetaDescription(description);
    }

    public SetMetaDescription(description: string) {
        this._translocoService.selectTranslate(description).pipe(
            tap(t => {
                const metaTitle = document.querySelector('meta[name="description"]');
                if (metaTitle) {
                    metaTitle.setAttribute('content', t);
                } else {
                    const newMetaTitle = document.createElement('meta');
                    newMetaTitle.setAttribute('name', 'description');
                    newMetaTitle.setAttribute('content', t);
                    document.head.appendChild(newMetaTitle);
                }
            }),
        ).subscribe();
    }

    public SetTwitterCard() {
        const twitterMeta = document.querySelector('meta[name="twitter:card"]');
        if (twitterMeta) {
            twitterMeta.setAttribute('content', 'summary_large_image');
        } else {
            const newMetaOg = document.createElement('meta');
            newMetaOg.setAttribute('name', 'twitter:card');
            newMetaOg.setAttribute('content', 'summary_large_image');
            document.head.appendChild(newMetaOg);
        }
    }

    public SetOgMeta(property: string, content: string) {
        const ogMeta = document.querySelector('meta[property="og:' + property + '"]');
        if (ogMeta) {
            ogMeta.setAttribute('content', content);
        } else {
            const newMetaOg = document.createElement('meta');
            newMetaOg.setAttribute('property', "og:" + property);
            newMetaOg.setAttribute('content', content);
            document.head.appendChild(newMetaOg);
        }
    }

    public SetMetaCanonicalLinkByUrl(url: string) {
        let canonicalUrl = this.resolveMetaCanonicalLinkByUrl(url);
        if (canonicalUrl == '') {
            const metaCanonical = document.querySelector('link[rel="canonical"]');
            if (metaCanonical) {
                metaCanonical.remove();
            }
        }
        else {
            const metaCanonical = document.querySelector('link[rel="canonical"]');
            if (metaCanonical) {
                metaCanonical.setAttribute('href', canonicalUrl);
            } else {
                const newMetaTitle = document.createElement('link');
                newMetaTitle.setAttribute('rel', 'canonical');
                newMetaTitle.setAttribute('href', canonicalUrl);
                document.head.appendChild(newMetaTitle);
            }
        }
    }

    private resolveMetaTitleByUrl(url: string): string {
        const urlPartsOfInterest = [
            'home',
            'terms-and-conditions',
            'privacy-policy',
            'sell-property-get-started',
            'sell-with-us',
            'loan-eligibility',
            'contact',
            'cookies-settings',
            'register',
            'login',
            'on-boarding-buyer',
            'on-boarding-seller',
            'faq',
            'about',
            'financing',
            'properties',
            'legalReport',
            'technicalReport',
            'preapproval',
            'propertyFileConstitution',
            'photography',
            'services'
        ];
        // Normalize and split the URL into path segments
        const pathSegments = url
            .split('?')[0]              // Remove query string
            .split('#')[0]              // Remove hash
            .split('/')                 // Split into parts
            .filter(Boolean);            // Remove empty strings

        // Look from last to first for a match
        const matchedPart = [...pathSegments].reverse().find((f: string) => urlPartsOfInterest.includes(f));
        const rs = matchedPart ? `seo.meta-title.${matchedPart}` : '';

        return rs;
    }

    private resolveMetaDesciptionByUrl(url: string): string {
        const urlPartsOfInterest = [
            'home',
            'terms-and-conditions',
            'privacy-policy',
            'sell-property-get-started',
            'sell-with-us',
            'loan-eligibility',
            'contact',
            'cookies-settings',
            'register',
            'login',
            'on-boarding-buyer',
            'on-boarding-seller',
            'faq',
            'about',
            'financing',
            'services',
            'properties',
            'legalReport',
            'technicalReport',
            'preapproval',
            'propertyFileConstitution',
            'photography'
        ];

        // Normalize and split the URL into path segments
        const pathSegments = url
            .split('?')[0]              // Remove query string
            .split('#')[0]              // Remove hash
            .split('/')                 // Split into parts
            .filter(Boolean);            // Remove empty strings

        // Look from last to first for a match
        const matchedPart = [...pathSegments].reverse().find((f: string) => urlPartsOfInterest.includes(f));
        const rs = matchedPart ? `seo.meta-description.${matchedPart}` : '';

        return rs;
    }


    private resolveMetaCanonicalLinkByUrl(url: string): string {
        if (url === '/') {
            return 'https://www.uniko.gr/el/home"';
        }
        // Handle property URLs
        if (url.startsWith('/properties/')) {
            return `https://www.uniko.gr/el${url}`;
        }
        return '';
    }
}